module.exports = __webpack_public_path__ + "static/media/2DGACM3.7f7979b6.jpg";